<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import translations from "./OrderAlreadyExists.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const {
		detailUrl,
		orderNumber,
		onclear,
		oncreate,
	}: {
		detailUrl: string;
		orderNumber: string | undefined;
		onclear(this: void): void;
		oncreate(this: void): void;
	} = $props();

	const message = $derived(
		orderNumber === undefined
			? translate("message", { detailUrl })
			: translate("messageWithNumber", { detailUrl, orderNumber }),
	);
</script>

<p class="mt-5 text-fcrdarkgray">
	<Formatted text={message} />
</p>
<div class="flex flex-col sm:flex-row sm:justify-end gap-4 mt-8">
	<Button
		variant={ButtonVariant.Outlined}
		size={ButtonSize.Medium}
		class="!leading-4"
		onclick={(): void => {
			oncreate();
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("createAnyway")} />
	</Button>
	<Button
		variant={ButtonVariant.Dark}
		size={ButtonSize.Medium}
		class="!leading-4"
		onclick={(): void => {
			onclear();
			Cart.closeCartModal();
		}}
	>
		<Formatted text={translate("clearCart")} />
	</Button>
</div>
